<template>
  <div class="pageview">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="120px"
    >
   <el-form-item label="类型" prop="type">
        <el-input v-model="queryParams.type" placeholder="请输入类型" learable @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="$refs.addImageType.addCreateForm(platForm)"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="类型" align="center" prop="type" />
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="450"
      >
  <template slot-scope="scope">
    <el-button size="mini" type="text" icon="el-icon-delete" @click="$refs.addImageType.showCreateForm(scope.row)">修改</el-button>
          <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
        </template> 
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
<addImageType ref="addImageType" @ok="getList"/>
  </div>
</template>

<script>
import {imageTypeList, imageTypeDel} from "@/api/imageType";

import addImageType from "@/views/system/imageType/addImageType";
export default {
  components: {
    addImageType
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platForm: "",
        type: null
      },
      loading: false,
      total: 0,
      dataList: [],
      showSearch: true,
        platForm: "",
        userId: "",
        userName: "",
        oriApi: "",
    };
  },
  created() {},
  mounted() {
    this.userId = this.$route.query.userId
    this.userName = this.$route.query.userName
    this.platForm = this.$route.query.platForm
    this.oriApi = this.$route.query.oriApi
    this.queryParams.platForm = this.$route.query.platForm
    this.getList()
  },
  methods: {
    getList() {
      imageTypeList(this.queryParams).then((response) => {
        const result = response.data.data;
        console.log(result);
        this.dataList = result.list;
        this.total = result.total;
      });
    },
    handleDelete(row) {
       const ids = row.id
      this.$modal.confirm('是否确认删除编号为"' + ids + '"的数据项？').then(function () {
        return imageTypeDel({
          id:ids
        })
      }).then(() => {
         this.getList()
        this.$modal.msgSuccess("删除成功")
      }).catch(() => { })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams= {
        pageNum: 1,
        pageSize: 10,
        platForm: this.platForm,
        type: null
      }
      this.handleQuery();
    },
  },
};
</script>
<style scoped>

</style>

